import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  paypalContainer: {
    marginTop: 30
  }
}))
